import { profileServiceRequest, skip } from "./utils";
import { DEFAULT_LIMIT_PER_PAGE } from "@/constants";

const todosSubmissionsService = {
  async getTodoSubmission({ id, ...params }) {
    return await profileServiceRequest({
      method: "get",
      url: `/onboarding/todos_submissions/${id}/`,
      failureMessage: "Error loading Todo Submissions data",
      params,
    });
  },
  async getTodosSubmissions({
    limit = DEFAULT_LIMIT_PER_PAGE,
    page = 1,
    q = "",
    extraParams = {},
  }) {
    return await profileServiceRequest({
      method: "get",
      url: "/onboarding/todos_submissions",
      params: {
        limit,
        skip: skip(page, limit),
        q,
        ...extraParams,
      },
      failureMessage: "Error loading Todo Submissions data",
    });
  },
  async createTodosSubmissions({ payload = {} }) {
    return await profileServiceRequest({
      method: "post",
      url: "/onboarding/todos_submissions",
      payload: payload,
    });
  },
  async updateTodosSubmissions({ todoSubmissionsId, payload = {} }) {
    if (todoSubmissionsId) {
      return await profileServiceRequest({
        method: "put",
        url: `/onboarding/todos_submissions/${todoSubmissionsId}`,
        payload: payload,
      });
    }
  },
};

export default todosSubmissionsService;
